import styled from 'styled-components/macro'
import DropdownTreeSelect from 'react-dropdown-tree-select'
import 'react-dropdown-tree-select/dist/styles.css'
import breakpoints from 'assets/stylesheet'

const StyledDropdownTreeSelect = styled(DropdownTreeSelect)`
  .dropdown {
    width: 100%;
    display: block !important;
    .tag-item {
      margin: 0;
      &:last-of-type {
        width: 100%;
      }
      .tag {
        display: none;
      }
    }
    .tag-item .search {
      border: 0;
      padding: 7px 10px;
      padding-right: 35px;
      width: 100%;
      color: black;
      font-size: 12px;
      height: 40px;
      border: 1px solid #003399;
      border-radius: 4px;
      &:focus {
        background-color: #fff;
        border: 1px solid #9faee5;
        box-shadow: 0 0 6px 0 #003399;
        color: #4a4a4a;
      }
      &:active {
        background-color: #fff;
        border: 1px solid #9faee5;
        box-shadow: 0 0 6px 0 #003399;
        color: #4a4a4a;
      }
    }
    .dropdown-trigger {
      width: 100%;
      line-height: normal !important;
      border: none !important;

      &:focus {
        border: none !important;
      }
      &::after {
        ${props =>
          props.hideIcon &&
          `
        display: none;
        `};
        display: none;
        font-family: 'Font Awesome 6 Pro' !important;
        content: '\f002' !important;
        color: #9faee5 !important;
        font-size: 24px;
        position: absolute;
        right: 10px;
        top: 10px;
      }
    }
  }
  .dropdown-content {
    position: relative !important;
    border: 0 !important;
    box-shadow: none !important;
    font-size: 12px;
    max-height: ${props => (props.maxHeight ? props.maxHeight : '300px')};
    overflow-y: auto;
    @media (max-width: ${breakpoints.bpTabletPx}) {
      max-height: 300px;
    }
    .node {
      white-space: normal;
      max-height: 45px;
      padding: 0;
      overflow: hidden;
      font-weight: 500;
      .toggle {
        display: none;
        &::after {
          display: none;
        }
      }
      & > label {
        display: block;
      }
    }
  }
  .dropdown .dropdown-trigger {
    display: ${props => (props.searchable ? 'block' : 'none')} !important;
  }
`

export default StyledDropdownTreeSelect
